import apiClient from './apiClient';

export const fetchClients  = ()         => apiClient.get('/clients').then(r => r.data.clients);
export const createClient  = (data)     => apiClient.post('/clients', data).then(r => r.data);
export const updateClient  = (id, data) => apiClient.put(`/clients/${id}`, data).then(r => r.data);
export const deleteClient  = (id)       => apiClient.delete(`/clients/${id}`).then(r => r.data);
